"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/BrandingTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _org = require('shared/selectors/org');
var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _useBroadcastVerification = require('web/screens/Broadcast/Verification/useBroadcastVerification'); var _useBroadcastVerification2 = _interopRequireDefault(_useBroadcastVerification);
var _BroadcastsVerification = require('web/components/Upsells/BroadcastsVerification');

var _Org = require('web/components/Settings/Org');
var _Form = require('web/components/Form');
var _LogoPicker = require('web/components/ClinicBranding/LogoPicker'); var _LogoPicker2 = _interopRequireDefault(_LogoPicker);
var _BrandingPreview = require('web/components/ClinicBranding/BrandingPreview'); var _BrandingPreview2 = _interopRequireDefault(_BrandingPreview);
var _logoUpload = require('web/components/ClinicBranding/logoUpload');
var _ColourField = require('./ColourField'); var _ColourField2 = _interopRequireDefault(_ColourField);

/* Settings → an org → Patient chat branding (P-3, SC-10): what patients see
 * on secure links and in the app. Admins of orgs with the BRANDING bit see
 * the tab; a verified clinic gets the form, an unverified one a note and
 * the request-verification action. The server checks admin, verification
 * and the bit again on every read, upload and save. */







// The website field shows the address without https://, as patients see it
// on the card, and saves it with https:// (D-11: https only). Anything
// that already names a scheme ("http://", "javascript:", "mailto:") is
// sent as typed, so the server refuses it; "host:port" isn't a scheme.
const SCHEME = /^(?:[a-z][a-z0-9+.-]*:\/\/|javascript:|mailto:|data:|tel:)/i
const withHttps = (website) => {
  const v = website.trim()
  return v && !SCHEME.test(v) ? `https://${v}` : v
}
const withoutHttps = (website) => website.replace(/^https:\/\//i, '')

const toInput = (d) => ({
  OrgKey: d.OrgKey,
  LogoPath: d.LogoPath,
  IconPath: d.IconPath,
  Color: d.Color,
  ContactCardEnabled: d.ContactCardEnabled,
  Website: withHttps(d.Website),
  MapsURL: d.MapsURL,
  Phone: d.Phone,
  Email: d.Email,
  Address: d.Address,
})



// Which field a save refusal is about, from the server's words (P-1).
const refusalField = (message) => {
  const m = message.toLowerCase()
  if (m.startsWith('the website')) return 'Website'
  if (m.startsWith('the directions link')) return 'MapsURL'
  if (m.includes('colour')) return 'Color'
  if (m.startsWith('phone can be')) return 'contact'
  return null
}













const Field = ({ label, value, onChange, type = 'text', placeholder, hint, maxLength, className, error }) => {
  const id = _react.useId.call(void 0, )
  const hintId = _react.useId.call(void 0, )
  const errorId = _react.useId.call(void 0, )
  const onInput = _react.useCallback.call(void 0, (e) => onChange(e.target.value), [onChange])
  return (
    _react2.default.createElement('div', { className: className ? `branding-field ${className}` : 'branding-field', __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
      , _react2.default.createElement('label', { htmlFor: id, className: "branding-field--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
        ,  label , " " , _react2.default.createElement('span', { className: "branding-field--optional", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Optional")
      )
      , _react2.default.createElement('input', {
        id: id,
        type: type,
        className: "blm-text-input",
        value: value,
        placeholder: placeholder,
        maxLength: maxLength,
        'aria-describedby': [error && errorId, hint && hintId].filter(Boolean).join(' ') || undefined,
        'aria-invalid': !!error,
        onChange: onInput, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
      )
      ,  error && _react2.default.createElement('p', { id: errorId, role: "alert", className: "branding-field--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}},  error ) 
      ,  hint && _react2.default.createElement('p', { id: hintId, className: "branding-field--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}},  hint ) 
    )
  )
}

const UnverifiedNote = ({ orgKey }) => {
  const { isRequested, isRequesting, onRequest } = _useBroadcastVerification2.default.call(void 0, orgKey, true)
  return (
    _react2.default.createElement('section', { className: "branding-card branding-unverified" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
      , _react2.default.createElement('h3', { className: "branding-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}, "Patient chat branding"  )
      , _react2.default.createElement('p', { className: "branding-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}, "Only verified clinics can brand their patient chats with a logo, colour and contact details. Ask BloomText to verify your clinic, and this page opens once it is."


      )
      ,  isRequested
        ? _react2.default.createElement('p', { className: "branding-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}},  _BroadcastsVerification.VERIFICATION_REQUESTED_HINT )
        : _react2.default.createElement(_Form.Button, { onClick: onRequest, isLoading: isRequesting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}, "Request verification" ) 
    )
  )
}

const BrandingForm = ({ orgKey, orgName }) => {
  const [saved, setSaved] = _react.useState(null)
  const [draft, setDraft] = _react.useState(null)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [saveError, setSaveError] = _react.useState(null)
  // Remounts the logo pickers on Cancel and Save, so an upload's file line
  // or refusal never outlives the values it was about.
  const [pickerKey, setPickerKey] = _react.useState.call(void 0, 0)
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )

  const load = _react.useCallback.call(void 0, 
    () => _actions2.default.getOrgBranding({ OrgKey: orgKey }).then((s) => {
      const shown = { ...s, Website: withoutHttps(s.Website) }
      setSaved(shown)
      setDraft(shown)
    }),
    [orgKey],
  )
  const hasLoadFailed = _useEntityPreload2.default.call(void 0, load)

  const set = _react.useCallback.call(void 0, (key, value) => {
    setDraft(d => d && { ...d, [key]: value })
    setSaveError(null)
  }, [])
  const setters = _react.useMemo.call(void 0, () => ({
    Color: (v) => set('Color', v),
    ContactCardEnabled: (v) => set('ContactCardEnabled', v),
    Phone: (v) => set('Phone', v),
    Email: (v) => set('Email', v),
    Website: (v) => set('Website', v),
    Address: (v) => set('Address', v),
    MapsURL: (v) => set('MapsURL', v),
    logo: (u) => setDraft(d => d && { ...d, LogoPath: u.Path, LogoURL: u.URL }),
    icon: (u) => setDraft(d => d && { ...d, IconPath: u.Path, IconURL: u.URL }),
    removeLogo: () => setDraft(d => d && { ...d, LogoPath: '', LogoURL: '' }),
    removeIcon: () => setDraft(d => d && { ...d, IconPath: '', IconURL: '' }),
  }), [set])

  const onSave = _react.useCallback.call(void 0, () => {
    if (!draft) return
    setIsSaving(true)
    setSaveError(null)
    _actions2.default.saveOrgBranding(toInput(draft))
      .then((s) => {
        const shown = { ...s, Website: withoutHttps(s.Website) }
        setSaved(shown)
        setDraft(shown)
        setPickerKey(k => k + 1)
        showSuccessBar('Branding saved')
      })
      .catch((e) => {
        const message = _logoUpload.refusalMessage.call(void 0, e, "Branding couldn't be saved. Try again.")
        setSaveError({ field: refusalField(message), message })
      })
      .finally(() => setIsSaving(false))
  }, [draft, showSuccessBar])

  const onCancel = _react.useCallback.call(void 0, () => {
    setDraft(saved)
    setSaveError(null)
    setPickerKey(k => k + 1)
  }, [saved])

  const fieldError = (field) => _optionalChain([saveError, 'optionalAccess', _ => _.field]) === field ? saveError.message : null

  const clinic = _react.useMemo.call(void 0, () => draft && {
    OrgKey: orgKey,
    Name: orgName,
    LogoURL: draft.LogoURL,
    IconURL: draft.IconURL,
    Color: draft.Color,
    Contact: {
      Phone: draft.Phone, Email: draft.Email, Website: withHttps(draft.Website), Address: draft.Address, MapsURL: draft.MapsURL,
    },
  }, [draft, orgKey, orgName])

  if (hasLoadFailed) {
    return _react2.default.createElement('p', { role: "alert", className: "branding-card--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}}, "Couldn't load your branding. Reload the page to try again."         )
  }
  if (!draft || !clinic) return null

  return (
    _react2.default.createElement('div', { className: "branding-layout", __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}
      , _react2.default.createElement('div', { className: "branding-form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}
        , _react2.default.createElement('section', { className: "branding-card", 'aria-labelledby': "branding-logo-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
          , _react2.default.createElement('h3', { id: "branding-logo-title", className: "branding-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}, "Logo and icon"  )
          , _react2.default.createElement('p', { className: "branding-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}, "Patients see these on secure links, and in the BloomText app if your clinic offers it. Pick a PNG or JPEG, then crop it; BloomText sizes it for you."                            )
          , _react2.default.createElement(_LogoPicker2.default, {
            key: `logo-${pickerKey}`,
            orgKey: orgKey,
            kind: "logo",
            inputLabel: "Upload logo" ,
            imageAlt: "Logo",
            url: draft.LogoURL,
            shape: "wide",
            title: "Logo",
            description: `Your full logo with your name in it. Shown alone at the top of the secure-link page and on the contact card. For the best fit, upload it without empty space around it. Without one, patients see "From: ${orgName}".`,
            onUploaded: setters.logo,
            onRemove: setters.removeLogo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
          )
          , _react2.default.createElement(_LogoPicker2.default, {
            key: `icon-${pickerKey}`,
            orgKey: orgKey,
            kind: "icon",
            inputLabel: "Upload icon" ,
            imageAlt: "Icon",
            url: draft.IconURL,
            shape: "square",
            roundPreview: true,
            title: "Icon",
            badge: "New",
            description: "A square mark, shown beside your teams' chats in the BloomText app, if your clinic offers it, when a team has no logo of its own, and on the contact card when you have no wide logo. You crop it to a square. Set team logos in Directory → Teams."                                                 ,
            onUploaded: setters.icon,
            onRemove: setters.removeIcon, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
          )
        )

        , _react2.default.createElement('section', { className: "branding-card", 'aria-labelledby': "branding-colour-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}
          , _react2.default.createElement('h3', { id: "branding-colour-title", className: "branding-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}, "Brand colour" )
          , _react2.default.createElement('p', { className: "branding-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}, "Used for your patients' messages, buttons and links. The purple page around the conversation always stays BloomText purple. We derive tints from it so every text and button stays readable."


          )
          , _react2.default.createElement(_ColourField2.default, { value: draft.Color, onChange: setters.Color, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}} )
          ,  fieldError('Color') && _react2.default.createElement('p', { role: "alert", className: "branding-field--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}},  fieldError('Color') ) 
        )

        , _react2.default.createElement('section', { className: "branding-card", 'aria-labelledby': "branding-contact-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
          , _react2.default.createElement('h3', { id: "branding-contact-title", className: "branding-card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}, "Contact details" )
          , _react2.default.createElement('p', { className: "branding-card--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}, "Patients see these when they tap ? in a conversation. Leave a field empty to hide it. Phone, Email and Address are your Organization info details, so editing them here updates both."


          )
          , _react2.default.createElement(_Form.Toggle, {
            className: "branding-contact--toggle",
            label: "Show to patients"  ,
            hint: "Off keeps ? opening BloomText help only."      ,
            isChecked: draft.ContactCardEnabled,
            onChange: setters.ContactCardEnabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
          )
          , _react2.default.createElement('div', { className: "branding-contact--grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
            , _react2.default.createElement(Field, { label: "Phone", type: "tel", value: draft.Phone, onChange: setters.Phone, maxLength: 25, __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}} )
            , _react2.default.createElement(Field, { label: "Email", type: "email", value: draft.Email, onChange: setters.Email, maxLength: 50, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}} )
            , _react2.default.createElement(Field, {
              className: "branding-field--wide",
              label: "Website",
              placeholder: "yourclinic.com",
              value: draft.Website,
              onChange: setters.Website,
              maxLength: 200,
              error: fieldError('Website'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}
            )
            , _react2.default.createElement(Field, { className: "branding-field--wide", label: "Address", value: draft.Address, onChange: setters.Address, maxLength: 100, __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}} )
            ,  fieldError('contact') && _react2.default.createElement('p', { role: "alert", className: "branding-field--error branding-field--wide" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}},  fieldError('contact') ) 
            , _react2.default.createElement(Field, {
              className: "branding-field--wide",
              label: "Google Maps link"  ,
              type: "url",
              placeholder: "https://maps.app.goo.gl/…",
              hint: "In Google Maps, find your clinic, tap Share and paste the link. Empty: Directions searches Google Maps for your address."                   ,
              value: draft.MapsURL,
              onChange: setters.MapsURL,
              maxLength: 500,
              error: fieldError('MapsURL'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}
            )
          )
        )

        , _react2.default.createElement('div', { className: "branding-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}}
          , _react2.default.createElement(_Form.Button, { onClick: onSave, isLoading: isSaving, __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}, "Save branding" )
          , _react2.default.createElement('button', { type: "button", className: "branding-actions--cancel", onClick: onCancel, disabled: isSaving, __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}}, "Cancel")
          , _react2.default.createElement('p', { className: "branding-actions--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}}, "Patients see changes the next time they open their link or the app."            )
        )
        ,  saveError && !saveError.field && _react2.default.createElement('p', { role: "alert", className: "branding-actions--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 297}},  saveError.message ) 
      )
      , _react2.default.createElement(_BrandingPreview2.default, { clinic: clinic, cardEnabled: draft.ContactCardEnabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}} )
    )
  )
}

const BrandingTab = ({ orgKey }) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgV1.call(void 0, state, orgKey))
  if (!org) return null
  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "branding", __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}}
      ,  org.Verified
        ? _react2.default.createElement(BrandingForm, { orgKey: orgKey, orgName: org.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}} )
        : _react2.default.createElement(UnverifiedNote, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}} ) 
    )
  )
}

exports. default = _react.memo.call(void 0, BrandingTab)
